const onLinkClick = (e) => {
	const linkView = e.target.closest('a.js-scroll-view[href^="#"]');
	if (linkView) {
		e.preventDefault();
		const id = String(linkView.getAttribute('href'));
		const elem = document.querySelector(id);
		if (elem) {
			console.log('view');
			elem.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	}
};
export const initLinkScroll = () => {
	document.addEventListener('click', onLinkClick);
	const elem = document.querySelector('#care-acne');
	window.addEventListener('scroll', () => {
		const result = elem.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
		console.log(result);
	});
};
